import VideoExamine from '../views/videoManagement/videoExamine'
import VideoList from '../views/videoManagement/videoList'
import PushList from '../views/videoManagement/pushList'
import CityList from '../views/videoManagement/cityList'
import TagList from '../views/videoManagement/tagList'
import ActiveConfig from '../views/videoManagement/activeConfig'
import CommentList from '../views/videoManagement/commentList'
import VideoHot from '../views/videoManagement/videoHot'
import HotCity from '../views/videoManagement/hotCity'
import ResourceManage from '../views/videoManagement/resourceManage'
import AutoPublishing from '../views/videoManagement/autoPublishing'
import FilterManagement from '../views/videoManagement/filterManagement'
import RecommendSignature from '../views/videoManagement/recommendSignature'
import GoldCoinVideoConfig from "../views/videoManagement/goldCoinVideoConfig";
import FreeVidCfg from '../views/videoManagement/freeVidCfg'
import VidResCfg from '../views/videoManagement/vidResCfg'
import HotSearchList from '../views/videoManagement/hotSearchList'
import HotSearchStatistics from '../views/videoManagement/hotSearchStatistics'
import TagConfiguration from "../views/videoManagement/tagConfiguration";
import QuickSearch from "../views/videoManagement/quickSearch";
import Main from '../views/main'

const VideoRouter = {
  path: '/video-examine',
  component: Main,
  title: '帖子管理',
  icon: 'el-icon-video-camera-solid',
  meta: { keepAlive: true },
  children: [
    {
      path: '/video-examine',
      component: VideoExamine,
      name: 'videoExamine',
      title: '帖子审核',
      meta: { title: '帖子审核' ,keepAlive:true}
    },
    {
      path: '/video-list',
      component: VideoList,
      name: 'videoList',
      title: '帖子列表',
      meta: { title: '帖子列表' ,keepAlive:true}
    },
    {
      path: '/autoPublishing',
      component: AutoPublishing,
      name: 'autoPublishing',
      title: '自动上架',
      meta: { title: '自动上架' ,keepAlive:true}
    },
    // 推送列表
    {
      path: '/push-list',
      component: PushList,
      name: 'pushList',
      title: '推送列表',
      meta: { title: '推送列表' ,keepAlive:true}
    },
    {
      path: '/tag-list',
      component: TagList,
      name: 'tagList',
      title: '标签管理',
      meta: { title: '标签管理' ,keepAlive:true}
    },
    {
      path: '/active-config',
      component: ActiveConfig,
      name: 'activeConfig',
      title: '活动配置',
      meta: { title: '活动配置' ,keepAlive:true}
    },
    {
      path: "/gold-coin-video-config",
      component: GoldCoinVideoConfig,
      name: "goldCoinVideoConfig",
      title: "金币视频配置",
      meta: { title: "金币视频配置", keepAlive: true },
    },
    {
      path: '/tag-configuration',
      component: TagConfiguration,
      name: 'tagConfiguration',
      title: '标签配置',
      meta: { title: '标签配置' ,keepAlive:true}
    },
    {
      path: '/city-list',
      component: CityList,
      name: 'cityList',
      title: '城市列表',
      meta: { title: '城市列表' ,keepAlive:true}
    },
    {
      path: '/hot-city',
      component: HotCity,
      name: 'hotCity',
      title: '热门城市',
      meta: { title: '热门城市' ,keepAlive:true}
    },
    {
      path: '/comment-list',
      component: CommentList,
      name: 'commentList',
      title: '评论管理',
      meta: { title: '评论管理' ,keepAlive:true}
    },
    {
      path: '/resource-management',
      component: ResourceManage,
      name: 'resourceManage',
      title: '资源管理',
      meta: { title: '资源管理' ,keepAlive:true}
    },
    {
      path: '/video-hot',
      component: VideoHot,
      name: 'videoHot',
      title: '短视频最热',
      meta: { title: '短视频最热' ,keepAlive:true}
    },
    {
      path: '/filter-management',
      component: FilterManagement,
      name: 'filterManagement',
      title: '过滤词管理',
      meta: { title: '过滤词管理' ,keepAlive:true}
    },
    {
      path: '/recommend-signature',
      component: RecommendSignature,
      name: 'recommendSignature',
      title: '推荐标签',
      meta: { title: '推荐标签' ,keepAlive:true}
    },
    {
      path: '/free-vid-cfg',
      component: FreeVidCfg,
      name: 'freeVidCfg',
      title: '免费观看配置',
      meta: { title: '免费观看配置' ,keepAlive:true}
    },
    {
      path: '/Hot-search-list',
      component: HotSearchList,
      name: '热搜词列表',
      title: '热搜词列表',
      meta: { title: '热搜词列表' ,keepAlive:true}
    },
    {
      path: '/hot-search-statistics',
      component: HotSearchStatistics,
      name: '热搜词统计',
      title: '热搜词统计',
      meta: { title: '热搜词统计' ,keepAlive:true}
    },
    {
      path: '/vid-res-cfg',
      component: VidResCfg,
      name: 'vidResCfg',
      title: '视频资源库',
      meta: { title: '视频资源库' ,keepAlive:true}
    },
    {
      path: "/quick-search",
      component: QuickSearch,
      name: "quickSearch",
      title: "快捷搜索列表",
      meta: {
        title: "快捷搜索列表",
        keepAlive: true,
      },
    },
  ]
}

export default VideoRouter
